import { loadPage } from './load-page';

export async function setupPage(pagesMap, currentPage) {
  try {
    await loadPage(pagesMap, currentPage);
  } catch (error) {
    console.error(error);
  }
};